/**
 * The miljöavgift row (P25009-484 BR-6): 25 kr per tyre, VAT included, on new
 * tyres and new complete wheels. The server adds it; this only names it, with
 * the tyre count so the buyer can see what it is for.
 */
import React from 'react';
import { intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_MILJOAVGIFT, propTypes } from '../../util/types';
import { miljoavgiftLabel } from '../../util/serviceTargetingCore';

import css from './OrderBreakdown.module.css';

const LineItemMiljoavgiftMaybe = props => {
  const { lineItems, intl } = props;

  const line = lineItems.find(item => item.code === LINE_ITEM_MILJOAVGIFT && !item.reversal);
  if (!line) {
    return null;
  }

  const tyres = Number(line.quantity?.toString?.() ?? line.quantity);
  // "Miljöavgift 4 × 25 kr" (P25009-484 BR-6).
  const label = Number.isFinite(tyres) && tyres > 0 ? miljoavgiftLabel(tyres) : 'Miljöavgift';

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>{label}</span>
      <span className={css.itemValue}>{formatMoney(intl, line.lineTotal)}</span>
    </div>
  );
};

LineItemMiljoavgiftMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemMiljoavgiftMaybe;
